import {nopListener} from "../utils"

export const makeExternalLinkDriver =  () => {
	return (sink$) => {
		sink$
			.map(({href, target}) => {
				if (!target || target == "_self") {
					window['location']['href'] = href
					return href;
				} else {
					const win = window.open(href, target);
					win.focus();
				}
			})
			.addListener(nopListener("externalLinkDriver"))
		return {
		}
	}
}

